module.exports = __webpack_public_path__ + "img/success.8648ba5b.svg";